import type { ReactNode } from "react";
import { RedLine } from "../rink/RedLine";

export interface PageHeaderProps {
  title: ReactNode;
  /** Optional row of actions, one primary at most. */
  actions?: ReactNode;
}

/**
 * Page title in display caps, optional actions, and the red line as the page horizon. Every operate
 * page renders this as its first element and passes only title and actions; the rule is included.
 */
export function PageHeader({ title, actions }: PageHeaderProps) {
  return (
    <header className="pb-4">
      <div className="flex flex-col gap-4 pb-4 sm:flex-row sm:items-end sm:justify-between">
        <h1 className="font-display text-3xl leading-[0.92] font-extrabold tracking-[0.01em] uppercase md:text-display-md">
          {title}
        </h1>
        {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
      </div>
      <RedLine />
    </header>
  );
}
